import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent,
  EmployeeWithProfile,
  PaginationComponent, ImportButton, DownloadButton
} from "@comps/components";
import { makeRequest, makeRequestStateless, handleDownloadFile } from "@utils/helpers";
import { Commons, Const, colors } from "../../constants";
import { Badge, Button, message, Tooltip } from 'antd';
import { FilterComponent, FilterButton } from "@comps/components";
import { deleteDataReq, getAllDataReq, getFilterReq, getRelatedDataReq } from "./requests";
import { useSelector } from "react-redux";
import CreateCompanyLend from "./components/CreateCompanyLend";
import dayjs from "dayjs";
import UpdateCompanyLend from "./components/UpdateCompanyLend";
import ViewFlow from "@mods/common/ViewFlow";
import ViewRequestHistory from "@mods/common/ViewRequestHistory";
import { getOnlyRequestFilters } from '@mods/common/commonFilterFields';
import { useLocation } from "react-router-dom";
import { downloadSampleReq } from "../../../common/requests";
import ImportSample from "../../../common/ImportSample";
import CompanyRequestFlowButton from "@mods/common/CompanyRequestFlowButton";
import ViewRepayments from "../lendApprovals/components/viewRepayments";
import { DollarOutlined } from "@ant-design/icons";
import { MoneyOutlined } from "@mui/icons-material";


const langKey = Const["companyLends"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["companyLends"].route
      }
    ]
  }
}

const IndexCompanyLends = (props) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [filters, setFilters] = useState('');

  const [allData, setAllData] = useState({})
  //start pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });
  //end pagination states

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const columns = [
    {
      key: 'code',
      title: trans(Commons.code),
      dataIndex: "code",
    },
    {
      key: 'employee',
      title: trans(`${langKey}.employee`),
      render: (record) => {
        return <EmployeeWithProfile record={ record.requestor } />
      },
    },
    {
      key: 'department_id',
      title: trans(`${langKey}.department_id`),
      render: (record) => {
        return record.requestor.department_name;
      }
    },
    {
      key: 'approved_amount',
      title: trans(`${langKey}.approved_amount`),
      render: (record) => {
        return record.approved_amount ? 'Rs ' + record.approved_amount : 'Rs ' + 0;
      }
    },
    {
      key: 'lend_type_name',
      title: trans(`${langKey}.lend_type_name`),
      render: (record) => {
        return record.lend_type_name;
      }
    },
    {
      key: 'effective_date',
      title: trans(`${langKey}.effective_date`),
      render: (record) => {
        return dayjs(record.effective_date).format('YYYY-MM-DD');
      }
    },
    {
      key: 'created_at',
      title: trans(`${langKey}.created_at`),
      render: (record) => {
        return dayjs(record.created_at).format('YYYY-MM-DD');
      }
    },

    {
      key: 'next_requestee',
      title: trans(`${langKey}.next_requestee`),
      render: (record) => {
        return <EmployeeWithProfile record={ record.next_requestee_name } />
      },
    },
    {
      key: 'status',
      title: trans(`${langKey}.status`),
      render: (record) => {
        return <Badge
          count={ record.status ? record.status : 'none' }
          style={ { background: colors[record.status_class], color: colors[record.status_class + '-color'] } }
        />
      }
    },

    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onViewHistory={ record.status !== 'Pending' ? onViewHistory : '' }
          onViewFlow={ record.flow.length !== 0 ? onViewFlow : '' }
          onEdit={ record.status === 'Pending' ? onEdit : '' }
          onView={ onView }
          onDelete={ props.modkey == "companyLends" ? onDelete : '' }

        >
          { record.status === 'Completed' ? (
            <Tooltip title="Repayments">
              <Button
                type="link"
                size="middle"
                onClick={ () => onViewRepayments(record) }
              >
                <MoneyOutlined className="icon-style da-text-color-info-1" />
              </Button>
            </Tooltip>
          ) : null }
        </ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  const location = useLocation();
  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [location.pathname, filters, currentPage]);

  const getAllData = () => {
    const payload = {
      page: currentPage,
      filters: props.filters + ';' + filters
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, onGetAllDataError);
  };

  const onSuccess = (response) => {
    setPagination(response.lends);
    setDataSource(response.lends.data);
    setAllData(response)

  };
  const onGetAllDataError = (err, res) => {
    message.error(res.response.data.message);
  }
  const onEdit = (record) => {
    setChildComponent(
      <UpdateCompanyLend onCompleted={ onCompleted } record={ record } disabled={ false } action='edit' allData={ allData } authUser={ authUser } source={ props.module } filters={ props.filters } />
    );
  };

  const onView = (record) => {
    setChildComponent(
      <UpdateCompanyLend onCompleted={ onCompleted } record={ record } disabled={ true } action='edit' allData={ allData } authUser={ authUser } source={ props.module } filters={ props.filters } />
    );
  };

  const onViewHistory = (record) => {
    setChildComponent(
      <ViewRequestHistory onCompleted={ onCompleted } record={ record } disabled={ true } />
    );
  };
  const onViewFlow = (record) => {
    setChildComponent(
      <ViewFlow onCompleted={ onCompleted } record={ record } disabled={ true } />
    );
  };
  const onViewRepayments = (record) => {
    makeRequest(setLoader, getRelatedDataReq, record.id, onSuccessViewRepayments, onGetAllDataError);
  };
  const onSuccessViewRepayments = (response) => {
    setChildComponent(
      <ViewRepayments
        onSaveRepayments={ () => setChildComponent(null) }
        approvedAmount={ response.lend?.approved_amount }
        record={ response.lend?.repayments || [] }
        disabled={ true }
      />
    );
  };
  const onDelete = (record) => {
    const payload = {
      filters: '', id: record.id
    }
    makeRequest(setLoader, deleteDataReq, payload, onDeleted, onError);
  };
  const onDeleted = (res) => {
    onSuccess(res)
    setDataSource(res.lends.data);
    message.success("Record Deleted")
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateCompanyLend onCompleted={ onCompleted } lends_of='company' allData={ allData } onSuccess={ onSuccess } authUser={ authUser } source={ props.module } filters={ props.filters } />);
  };

  const onCompleted = (data) => {
    if (data.length) {
      setDataSource(data);
      getAllData();
    }

    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ getFilterFields(props.module) } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }

  //----end filter--------------------
  //download sample log
  const onDownloadSample = () => {
    makeRequestStateless(downloadSampleReq, 'companylends/downloadSample', onSuccessDownloadSample, onSuccessDownloadSample);
  }
  const onSuccessDownloadSample = (res, err) => {
    if (res.code === undefined) {
      // Extract file extension
      const fileExtension = res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'xlsx' : 'pdf'
      const fileName = `loan_requests.${fileExtension}`
      handleDownloadFile(fileName, res)
    }
    else {
      message.error(res.message)
    }
  }


  return (
    <>

      { childComponent }
      <BodyComponent>
        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
          { props.modkey === 'companyLends' && <CompanyRequestFlowButton typeId="lend_request" /> }
          { props.modkey === 'companyLends' && <>
            <ImportButton onClick={ () => setChildComponent(<ImportSample onSuccess={ getAllData } api="companylends/import" module="Loans" onCompleted={ () => setChildComponent(null) } />) } />
            <DownloadButton onClick={ onDownloadSample } />
          </> }

          <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } />
          <FilterButton onClick={ onOpenFilter } />
        </HeaderComponent>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexCompanyLends;
const getFilterFields = (module) => getOnlyRequestFilters({ includeLendType: true, hideSelfScopeFilters: module === 'my-requests' })
